import { render, staticRenderFns } from "./DiscoveryMaterial.vue?vue&type=template&id=5329c6b0&scoped=true&"
import script from "./DiscoveryMaterial.vue?vue&type=script&lang=js&"
export * from "./DiscoveryMaterial.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/discovery_material.css?vue&type=style&index=0&id=5329c6b0&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/pc/vocabulary_tooltip.css?vue&type=style&index=1&id=5329c6b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329c6b0",
  null
  
)

export default component.exports